export const msgZoomIn = "Click to zoom in";
export const msgZoomOut = "Click to zoom out";
export const msgZoomExplore = "Click and drag to explore";
export const msgZoomPinch = "Pinch to Zoom";
